import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Layout/Header';
import Sidebar from './components/Layout/Sidebar';
import MobileSidebar from './components/Layout/MobileSidebar';
import Dashboard from './pages/Dashboard';
import Logs from './pages/Logs';
import Proxies from './pages/Proxies';
import Rules from './pages/Rules';
import Tokens from './pages/Tokens';
import Channels from './pages/Channels';
import Queue from './pages/Queue';
import Notifications from './pages/Notifications';
import Admin from './pages/Admin';
import Profile from './pages/Profile';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Login from './pages/Login'; 
import Settings from './pages/Settings';

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();
  const [sidebarVisible, setSidebarVisible] = useState(false);

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  // pages without layout (no header/sidebar)
  const noLayoutRoutes = ['/login'];

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      {/* Header - only show if not on login page */}
      {!noLayoutRoutes.includes(location.pathname) && (
        <Header toggleSidebar={toggleSidebar} />
      )}

      {/* Main Layout - only show if not on login page */}
      {!noLayoutRoutes.includes(location.pathname) ? (
        <div className="d-flex flex-grow-1">
          {/* Desktop Sidebar */}
          <div className="d-none d-lg-block">
            <Sidebar />
          </div>

          {/* Mobile Sidebar */}
          <MobileSidebar 
            visible={sidebarVisible} 
            onHide={() => setSidebarVisible(false)} 
          />

          {/* Main Content */}
          <main className="flex-grow-1 p-4" style={{ backgroundColor: '#f8f9fa' }}>
            <div className="container-fluid">
              <Routes>
                <Route path="/" element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } />
                <Route path="/tokens" element={
                  <ProtectedRoute>
                    <Tokens />
                  </ProtectedRoute>
                } />
                <Route path="/proxies" element={
                  <ProtectedRoute>
                    <Proxies />
                  </ProtectedRoute>
                } />
                <Route path="/channels" element={
                  <ProtectedRoute>
                    <Channels />
                  </ProtectedRoute>
                } />
                <Route path="/queue" element={
                  <ProtectedRoute>
                    <Queue />
                  </ProtectedRoute>
                } />
                <Route path="/rules" element={
                  <ProtectedRoute>
                    <Rules />
                  </ProtectedRoute>
                } />
                <Route path="/logs" element={
                  <ProtectedRoute>
                    <Logs />
                  </ProtectedRoute>
                } />
                <Route path="/notifications" element={
                  <ProtectedRoute>
                    <Notifications />
                  </ProtectedRoute>
                } />
                <Route path="/settings" element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                } />
                <Route path="/admin" element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                } />
                <Route path="/profile" element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </main>
        </div>
      ) : (
        // Show login page without layout
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      )}
    </div>
  );
}


export default App;